import React, { useEffect, useState } from "react";
import {
  Tabs,
  Tab,
  Box,
  Popover,
  List,
  Typography,
  FormControl,
  Select,
  InputLabel,
  ListItem,
  ListItemIcon,
  Checkbox,
  MenuItem,
  makeStyles
} from "@material-ui/core";
import clsx from "clsx";
import { connect } from "react-redux";
import SmallSearchBox from "./SmallSearchBox";
import { compare } from "../../utils/helpers";

const usePopoverStyles = makeStyles(theme => ({
  root: {
    zIndex: ({ editStop, inDialog }) =>
      editStop
        ? `${1300} !important`
        : inDialog
        ? `${1305} !important`
        : undefined
  },
  tab: {
    minWidth: 0,
    lineHeight: "1rem",
    padding: theme.spacing(2, 0),
    margin: theme.spacing(0, 2),
    textTransform: "none"
  },
  tabsRoot: {
    padding: theme.spacing(0),
    borderTop: "1px solid #ddd",
    borderBottom: "1px solid #ddd"
  },
  listWrapper: {
    height: 216,
    overflow: "auto"
  },
  checkboxWrapper: {
    margin: theme.spacing(-1.125, -1, -1.125, -1.125),
    "& .MuiSvgIcon-root": {
      color: "inherit"
    }
  },
  noTags: {
    textAlign: "center",
    fontSize: "0.875rem",
    marginTop: theme.spacing(1)
  },
  searchBox: {
    width: "100%"
  }
}));

const useInputLabelStyles = makeStyles(theme => ({
  root: {
    backgroundColor: "#fff"
  }
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={0}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function SelectTagPopover({ el, classes, editStop, sortedTags, inDialog }) {
  const popoverClasses = usePopoverStyles({ editStop, inDialog });
  const [anchorEl, setAnchorEl] = useState(null);
  const inputLabelClasses = useInputLabelStyles();

  const {
    topMargin,
    selected,
    labelId,
    selectId,
    name,
    type,
    disabled,
    // options,
    onChange,
    label
  } = el;
  const [value, setValue] = useState(type === "driver" ? 1 : 0);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const [searchInputValue, setSearchInputValue] = useState("");
  const handleFilter = (tag, value) => {
    return (tag.name || "").toLowerCase().indexOf(value.toLowerCase()) !== -1;
  };

  const handleSearchChange = val => {
    setSearchInputValue(val);
  };

  const [tags, setTags] = useState({
    driverTags: [],
    vehicleTags: []
  });

  const [filteredTags, setFilteredTags] = useState({
    driverTags: [],
    vehicleTags: []
  });

  const open = Boolean(anchorEl);
  const id = open ? "tags-popover" : undefined;
  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    if (anchorEl) {
      setTimeout(() => window.dispatchEvent(new CustomEvent("resize")), 100);
    }
    setSearchInputValue("");
  }, [anchorEl]);

  const sortTagsByName = tags => {
    return [...tags].sort((tag1, tag2) => {
      const tag1Selected = selected.includes(tag1.id);
      const tag2Selected = selected.includes(tag2.id);
      const addValue =
        tag1Selected && tag2Selected
          ? 0
          : tag1Selected
          ? -2
          : tag2Selected
          ? 2
          : 0;
      return compare(tag1.name, tag2.name) + addValue;
    });
  };

  useEffect(() => {
    if (anchorEl) {
      setTags({
        driverTags: sortTagsByName(sortedTags.driverTags),
        vehicleTags: sortTagsByName(sortedTags.vehicleTags)
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [anchorEl, sortedTags]);

  useEffect(() => {
    const newFilteredTags = {
      driverTags: tags.driverTags.filter(tag =>
        handleFilter(tag, searchInputValue)
      ),
      vehicleTags: tags.vehicleTags.filter(tag =>
        handleFilter(tag, searchInputValue)
      )
    };
    setFilteredTags(newFilteredTags);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchInputValue, tags]);

  const selectValue = selected.length ? `${selected.length} selected` : "";

  const noTagsMessage =
    searchInputValue.length &&
    (!filteredTags.vehicleTags.length || !filteredTags.driverTags.length)
      ? "No tags matched your search"
      : "No tags to display";
  console.log(label);
  return (
    <FormControl
      key={name}
      margin="normal"
      variant="outlined"
      className={clsx(classes.inputField, {
        [classes.topMargin]: topMargin,
        [classes.borderStyle]: editStop
      })}
    >
      <InputLabel
        id={labelId}
        shrink={selectValue || Boolean(anchorEl)}
        classes={{
          root: clsx(classes.inputLabel, inputLabelClasses.root)
        }}
        className={Boolean(anchorEl) ? "Mui-focused" : ""}
      >
        {label}
      </InputLabel>
      <Select
        labelId={labelId}
        id={selectId}
        value={selectValue}
        name={name}
        fullWidth
        className={Boolean(anchorEl) ? "Mui-focused" : ""}
        disabled={disabled}
        open={false}
        onClick={e => {
          !disabled && setAnchorEl(e.currentTarget);
        }}
      >
        <MenuItem value={selectValue}>{selectValue}</MenuItem>
      </Select>
      <Popover
        id={id}
        open={open}
        PaperProps={{
          style: { width: "384px" }
        }}
        classes={{
          root: popoverClasses.root
        }}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center"
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center"
        }}
      >
        <Box p={1}>
          <SmallSearchBox
            className={popoverClasses.searchBox}
            searchText={searchInputValue}
            onSearchChanged={handleSearchChange}
            ariaLabel="Search tags"
            dataCy="tags-search"
          />
        </Box>
        <Tabs
          className={popoverClasses.tabsRoot}
          indicatorColor="primary"
          value={value}
          onChange={handleTabChange}
        >
          <Tab
            className={popoverClasses.tab}
            label={`Vehicle (${sortedTags.vehicleTags.length})`}
            disabled={type === "driver"}
            id="tagSelect-vehicleTab"
          />
          (
          <Tab
            className={popoverClasses.tab}
            label={`Driver (${sortedTags.driverTags.length})`}
            disabled={type === "vehicle"}
            id="tagSelect-driverTab"
          />
          )
        </Tabs>
        <TabPanel
          className={popoverClasses.listWrapper}
          value={value}
          index={0}
        >
          <List>
            {type !== "driver" &&
              (!!filteredTags.vehicleTags.length ? (
                filteredTags.vehicleTags.map(tag => (
                  <ListItem
                    button
                    onClick={() => onChange(tag)}
                    className={classes.menuItem}
                    key={tag.id}
                    id={`vehicleTagRow-${tag.name}`}
                  >
                    <ListItemIcon className={popoverClasses.checkboxWrapper}>
                      <Checkbox
                        color="primary"
                        disableRipple
                        checked={selected.includes(tag.id)}
                        id={`tag-${tag.name}-checkbox`}
                        value={tag.name}
                        // onChange={() => onChange(tag)}
                      />
                    </ListItemIcon>
                    <Typography noWrap>{tag.name}</Typography>
                  </ListItem>
                ))
              ) : (
                <Typography className={popoverClasses.noTags} noWrap>
                  {noTagsMessage}
                </Typography>
              ))}
          </List>
        </TabPanel>
        <TabPanel
          value={value}
          index={1}
          className={popoverClasses.listWrapper}
        >
          <List>
            {type !== "vehicle" &&
              (filteredTags.driverTags.length ? (
                filteredTags.driverTags.map(tag => (
                  <ListItem
                    className={classes.menuItem}
                    key={tag.id}
                    id={`driverTagRow-${tag.name}`}
                  >
                    <ListItemIcon className={popoverClasses.checkboxWrapper}>
                      <Checkbox
                        color="primary"
                        disableRipple
                        checked={selected.includes(tag.id)}
                        onChange={() => onChange(tag)}
                        id={`tag-${tag.name}-checkbox`}
                        value={tag.name}
                      />
                    </ListItemIcon>
                    <Typography noWrap>{tag.name}</Typography>
                  </ListItem>
                ))
              ) : (
                <Typography className={popoverClasses.noTags} noWrap>
                  {noTagsMessage}
                </Typography>
              ))}
          </List>
        </TabPanel>
      </Popover>
    </FormControl>
  );
}

const mapStateToProps = state => ({
  sortedTags: state.account.sortedTags
});

export default connect(mapStateToProps)(SelectTagPopover);
